import { render, staticRenderFns } from "./ListOTView.vue?vue&type=template&id=0b8c0e32&lang=pug"
import script from "./ListOTView.vue?vue&type=script&lang=js"
export * from "./ListOTView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports